import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Error404 from '../Pages/Error404';
import {
  Login,
  Dashboard,
  Convenor_SignatureCourseList,
  ConvenorChangePassword,
  ConvenorForgetPassword,
  ConvenorNewPassword
} from '../Pages/Convenor'; 
import ProtectedRoute from '../component/ProtectedRoute';
const ConvenorRoutes = () => (

  <Routes>
    <Route path="/" element={<Login />} />
    <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} role={28} />} />
    <Route path="/convenorsignaturecourselist" element={<ProtectedRoute element={<Convenor_SignatureCourseList />} role={28} />} />
    <Route path="/convenor-signature-course-list" element={<ProtectedRoute element={<Convenor_SignatureCourseList />} role={28} />} />
    <Route path="/convenor_signaturecourselist" element={<ProtectedRoute element={<Convenor_SignatureCourseList />} role={28} />} />
    <Route path="/signature-course-list" element={<ProtectedRoute element={<Convenor_SignatureCourseList />} role={28} />} />
    <Route path="/aca12forwardedsignaturecourselist" element={<ProtectedRoute element={<Convenor_SignatureCourseList />} role={28} />} />
    <Route path="/ConvenorChangePassword" element={<ProtectedRoute element={<ConvenorChangePassword />} role={28} />} />
    <Route path="/ConvenorForgetPassword" element={<ConvenorForgetPassword />} />
    <Route path="/ConvenorNewPassword" element={<ConvenorNewPassword />} />
    <Route path="*" element={<Error404 />} />
    </Routes>   
);

export default ConvenorRoutes;  